import request from "@/utils/request";
export function login(data) {
  return request({
    url: "/api/login/user/back",
    method: "post",
    data,
  });
}
